import { getCategoriaLabel } from 'utils/iniciativa-categoria';
import type { ExtratoItemDTO } from 'types/extrato';
import type { ExtratoIniciativa } from './components/Extrato';

type StatusMotivo = 'impedimento' | 'requisitos' | 'nao_confirmado' | null;

export function deriveStatus(requisito: string): {
  participacaoConfirmada: boolean;
  statusMotivo: StatusMotivo;
} {
  switch (requisito) {
    case 'Apto':
      return { participacaoConfirmada: true, statusMotivo: null };
    case 'Impedido':
      return { participacaoConfirmada: false, statusMotivo: 'impedimento' };
    case 'Não cumpriu pré-requisito':
      return { participacaoConfirmada: false, statusMotivo: 'requisitos' };
    case 'Não confirmado':
      return { participacaoConfirmada: false, statusMotivo: 'nao_confirmado' };
    default:
      return { participacaoConfirmada: false, statusMotivo: null };
  }
}

export function formatCurrency(value: number): string {
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

/**
 * Observação da IN 403-1 item 7.2.8.6.3 quando o valor bruto per-capita atinge
 * exatamente o piso (R$ 500) ou o teto (R$ 10.000).
 * Premissa: o backend já aplica o clamping para 500/10000 exatos quanto o
 * piso/teto é atingido — por isso a comparação por igualdade é segura.
 */
export function computeObservacao(valorBruto: number): string | null {
  if (valorBruto === 500) {
    return 'IN 403-1 item 7.2.8.6.3 valor mínimo por pessoa R$ 500,00';
  }
  if (valorBruto === 10000) {
    return 'IN 403-1 item 7.2.8.6.3 valor máximo por pessoa R$ 10.000,00';
  }
  return null;
}

export function mapToExtratoIniciativa(item: ExtratoItemDTO): ExtratoIniciativa {
  const { participacaoConfirmada, statusMotivo } = deriveStatus(item.requisito);
  return {
    id: item.id_realizacao,
    titulo: item.titulo,
    variant: 'classificada-etapa1',
    categoriaLabel: getCategoriaLabel(item.categoria),
    participacaoConfirmada,
    statusMotivo,
    observacaoStatus: computeObservacao(item.valorBruto ?? 0),
    valores: [
      { rotulo: 'Valor de prêmio', valor: formatCurrency(item.valorPremio ?? 0) },
      {
        rotulo: 'Quantidade de participantes válidos',
        valor: String(item.qtdParticipantesValidos ?? 0),
      },
      { rotulo: 'Valor bruto', valor: formatCurrency(item.valorBruto ?? 0) },
    ],
  };
}
